/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {printQrCodes} from '../api'

export const useMutationPrintQrCodes = createReactQueryMutationHook('printQrCodes', printQrCodes)
